export const TIMEZONE = [
    { label: 'Alaska', value: 'alaska' },
    { label: 'Arizona', value: 'arizona' },
    { label: 'Central', value: 'central' },
    { label: 'Eastern', value: 'eastern' },
    { label: 'Mountain', value: 'mountain' },
    { label: 'Mountain', value: 'mountain' },
    { label: 'Pacific', value: 'pacific' },
];
